var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"alt":"loading","src":require("@/assets/loading.gif")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }